// prompts.<area>.<key>: the suggested questions (services/platform-agent/platformAgentSuggestions.js), sent as typed.
// {{dish}} is a dish on the restaurant's menu, {{amount}} an amount in its currency (both from the picker).
export default {
  title: 'Salut, {{first_name}}, ce ai nevoie pentru {{restaurant}}?',
  title_no_name: 'Salut, de ce ai nevoie pentru {{restaurant}}?',
  text: 'Pot răspunde la întrebări despre {{restaurant}} și pot face modificări pentru tine. Nimic nu se schimbă până nu aprobi.',
  suggestions: 'Sugestii',
  // No restaurant selected (D18): Amigo asks which restaurant; the prompts let it ask for the restaurant's name.
  no_restaurant: {
    title: 'Salut, {{first_name}}, pentru ce restaurant este?',
    title_no_name: 'Salut, pentru ce restaurant este?',
    text: 'Scrie numele restaurantului în mesaj și mă ocup eu de el, fără să-l deschizi mai întâi. Nimic nu se schimbă până nu aprobi.',
    prompts: {
      sunday_hours: 'Schimbă programul de duminică al unui restaurant la 12:00–21:00',
      close_several: 'Închide mai multe restaurante pe 24 decembrie',
    },
  },
  prompts: {
    reports: {
      top_dishes: 'Care au fost cele mai vândute 10 feluri de mâncare luna trecută?',
      sales_vs_last_month: 'Cum au evoluat vânzările față de luna trecută?',
    },
    menu: {
      raise_dish_price: 'Majorează prețul pentru {{dish}} cu {{amount}}',
      dish_sold_out: 'Marchează {{dish}} ca epuizat',
      dishes_without_photo: 'Care feluri de mâncare nu au poză?',
    },
    hours: {
      holiday_hours: 'Schimbă programul nostru de deschidere pentru 24 decembrie',
    },
    order_settings: {
      minimum_order: 'Crește comanda minimă la {{amount}}',
    },
    marketing: {
      promo_code: 'Creează un cod promoțional de 10 % pentru acest weekend',
    },
    my_info: {
      phone_number: 'Actualizează numărul nostru de telefon',
    },
  },
};
